const IST = 'Asia/Kolkata';

function parseDate(value) {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** Date in IST, e.g. 13 Aug 2026 */
export function formatIndianDate(value) {
  const d = parseDate(value);
  if (!d) return '';
  return new Intl.DateTimeFormat('en-IN', {
    timeZone: IST,
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(d);
}

/** 12-hour IST time, e.g. 8:42 pm */
export function formatIndianTime(value) {
  const d = parseDate(value);
  if (!d) return '';
  return new Intl.DateTimeFormat('en-IN', {
    timeZone: IST,
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(d);
}

/** 12-hour IST time with seconds, e.g. 8:42:05 pm */
export function formatIndianTimeWithSeconds(value) {
  const d = parseDate(value);
  if (!d) return '';
  return new Intl.DateTimeFormat('en-IN', {
    timeZone: IST,
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  }).format(d);
}

/** Weekday in IST, e.g. Friday */
export function formatIndianWeekday(value) {
  const d = parseDate(value);
  if (!d) return '';
  return new Intl.DateTimeFormat('en-IN', {
    timeZone: IST,
    weekday: 'long',
  }).format(d);
}

/** Live-clock friendly parts: day, date, time (with seconds). */
export function getIndianClockParts(value = new Date()) {
  return {
    day: formatIndianWeekday(value),
    date: formatIndianDate(value),
    time: formatIndianTimeWithSeconds(value),
  };
}

/** `{ date, time, combined }` in Indian 12-hour IST. */
export function formatIndianDateTimeParts(value) {
  const date = formatIndianDate(value);
  const time = formatIndianTime(value);
  return {
    date,
    time,
    combined: date && time ? `${date}, ${time}` : date || time || '',
  };
}

/** Single-line IST datetime, e.g. `13 Aug 2026, 5:35 pm`. Empty string if invalid. */
export function formatIndianDateTime(value) {
  return formatIndianDateTimeParts(value).combined;
}

/** Calendar days between a past date and today (IST). Same day → 0. */
export function daysPassedSince(value) {
  const d = parseDate(value);
  if (!d) return null;
  const start = new Date(
    new Intl.DateTimeFormat('en-CA', {
      timeZone: IST,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(d),
  );
  const today = new Date(
    new Intl.DateTimeFormat('en-CA', {
      timeZone: IST,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(new Date()),
  );
  const diffMs = today.getTime() - start.getTime();
  if (diffMs < 0) return 0;
  return Math.floor(diffMs / (24 * 60 * 60 * 1000));
}

/** e.g. "Today (0 days)", "1 day", "12 days" */
export function formatDaysPassed(value) {
  const days = daysPassedSince(value);
  if (days == null) return '';
  if (days === 0) return 'Today (0 days)';
  if (days === 1) return '1 day';
  return `${days} days`;
}
